import { AnalyticsBrowser } from "@segment/analytics-next";
import * as sessionReplay from "@amplitude/session-replay-browser";
import Cookies from "js-cookie";

const amplitudeApiKey = process.env.REACT_APP_AMPLITUDE_API_KEY;

const analytics = AnalyticsBrowser.load({
  writeKey: process.env.REACT_APP_SEGMENT_WRITE_KEY,
});

const getStoredSessionId = () => {
  return Cookies.get("analytics_session_id") || "0";
};

analytics.ready(async () => {
  const user = await analytics.user();

  const waitForAnonId = () =>
    new Promise((resolve) => {
      const check = () => {
        const id = user.anonymousId();
        if (id) resolve(id);
        else setTimeout(check, 100);
      };
      check();
    });

  const deviceId = await waitForAnonId();

  const storedSessionId = Cookies.get("analytics_session_id") || "0";

  const initResult = sessionReplay.init(amplitudeApiKey, {
    sessionId: storedSessionId,
    deviceId,
  });

  await initResult.promise;

  // Middleware para actualizar session_id desde Segment
  analytics.addSourceMiddleware(({ payload, next }) => {
    const stored = getStoredSessionId();
    const nextId =
      payload?.obj?.integrations?.["Actions Amplitude"]?.session_id || "0";

    if (parseInt(stored) < parseInt(nextId)) {
      Cookies.set("analytics_session_id", nextId);
      sessionReplay.setSessionId(nextId);
    }

    next(payload);
  });

  // Middleware para adjuntar propiedades de Session Replay
  analytics.addSourceMiddleware(({ payload, next }) => {
    const replayProps = sessionReplay.getSessionReplayProperties();

    if (payload.type() === "track") {
      payload.obj.properties = {
        ...payload.obj.properties,
        ...replayProps,
      };
    }

    next(payload);
  });
});

export default analytics;
